import queryString from 'query-string';

export function buildPaginationUrl(url, page = 0, size = 20, otherParams = {}) {
    let params = {
        ...otherParams,
        limit: size,
        offset: page * size,
        page: undefined
    };
    return `${url}?${queryString.stringify(params)}`;
}



// WEBPACK FOOTER //
// ./src/js/utils/url.js